import React, { useEffect, useState } from 'react';
import { HeaderWrapper, TextStyles } from './header-styles';
var Header = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, daysString = _a.daysString, nightsString = _a.nightsString;
    var DEFAULT_DATE = '--';
    var _b = useState(DEFAULT_DATE), text = _b[0], setText = _b[1];
    var _c = useState(0), period = _c[0], setPeriod = _c[1];
    useEffect(function () {
        var startTime = startDate === null || startDate === void 0 ? void 0 : startDate.valueOf();
        var endTime = endDate === null || endDate === void 0 ? void 0 : endDate.valueOf();
        if (startTime && endTime && endTime > startTime) {
            setPeriod((endTime - startTime) / 86400000);
            setText(period + 1 + " " + daysString + ", " + period + " " + nightsString);
        }
        else {
            setPeriod(0);
            setText(DEFAULT_DATE);
        }
    }, [startDate, endDate, period, text, daysString, nightsString]);
    return (React.createElement(HeaderWrapper, null,
        React.createElement(TextStyles, null, text)));
};
export default Header;
